<div class="container-fluid" [formGroup]="group">
    <h4 class="section-title">Digital Video Format Settings</h4>
    <hr>
    <div class="container-fluid digital-video-parent-section" *ngFor="let item of tactics.controls; let i = index;"
        formArrayName="tactics">
        <div [formGroupName]="i">
            <section>
                <label class="font-weight-bold" id="DL-environments{{i+1}}">ENVIRONMENTS</label>
                <ng-multiselect-dropdown [ngClass]="{ 'error': environment.touched && environment.errors }"
                    [placeholder]="'Add Environments'" [data]="environments" [settings]="dropdownSettings"
                    (onDeSelect)="onItemSelect($event)" (onSelect)="onItemSelect($event)"
                    (onDeSelectAll)="onItemSelect($event)" [(selectedData)]="selectedEnv" [disabled]="isDisabled">
                </ng-multiselect-dropdown>
                <div *ngIf="environment.touched && environment.errors" class="error-feedback">
                    <span>Environment cannot be empty, at least one environment must be selected</span>
                </div>
            </section>
            <hr>
            <!--Commenting it as its not supported for V1 as per [CSYS-4705]-->
            <!-- <section>
                <label class="font-weight-bold">LINEAR VIEWERSHIP AUDIENCE</label>
                <div>
                    <acl-ngx-checkbox
                        label="I would like to include audiences created by Amobee based off my linear schedule"
                        formControlName="useLinearSchedule"></acl-ngx-checkbox>
                    <div>Optional text - information about additional cost</div>
                </div>
            </section>
            <hr> -->
            <section>
                <goals class="row" [group]="i" [formArray]="tactics" [isNew]="isNew" [hasDefaults]="hasDefaults"
                    [advertiserInfo]="advertiserInfo" [tacticsVO]="digitalVideoVO?.tactics" [status]="status">
                </goals>
            </section>
            <hr>
            <section>
                <third-party-cost class="row" [group]="i" [formArray]="tactics" [advertiserInfo]="advertiserInfo"
                    [tacticsVO]="digitalVideoVO?.tactics[i]">
                </third-party-cost>
            </section>
            <hr>
            <section>
                <label class="font-weight-bold">INVENTORY MANAGEMENT</label>
                <div>
                    <small>Select inventory sources you want included in your plan</small>
                </div>
                <inventory-management [group]="i" [formArray]="tactics" [isNew]="isNew"
                    [advertiserInfo]="advertiserInfo">
                </inventory-management>
            </section>
            <hr>
            <!--Not supported for V1 as per [CSYS-5054]-->
            <!-- <section class="row">
                <div class="col border-right">
                    <label class="font-weight-bold">MAX CREATIVE LENGTH</label>
                    <select class="form-control border-bottom" formControlName="videoDuration">
                        <option *ngFor="let item of videoDurationConst | keyvalue" value={{item.value.id}}>
                            {{item.value.label}}</option>
                    </select>
                </div>
                <div class="col">
                    <label class="font-weight-bold">CREATIVE TYPE</label>
                    <div>
                        <acl-ngx-radio formControlName="vpaid" [value]="false">VAST
                        </acl-ngx-radio>
                    </div>
                    <div>
                        <acl-ngx-radio formControlName="vpaid" [value]="true">VPAID
                        </acl-ngx-radio>
                    </div>
                </div>
            </section> -->
            <section>
                <div class="margin-bottom-20">
                    <label class="font-weight-bold">Targeting</label>
                    <i class="optional-text">&nbsp;(Optional)</i>
                </div>
                <targeting [group]="i" [formArray]="tactics" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
                </targeting>
            </section>
        </div>
    </div>
</div>